// extracted by mini-css-extract-plugin
module.exports = {"navbar":"App_navbar__3truX","container":"App_container__1sINv","app":"App_app__2I7Ip"};